// @flow

import React from 'react'
import PT from 'prop-types'
import {
  DocumentTitle,
  HeaderTitle,
  Page,
} from '@vimcar/shared-components/components/AppLayout'

import { type Kiosk } from '#components/KioskProvider'
import i18n from '#utils/i18n'
import ProfilePreferences from '#components/ProfilePreferences'
import ProfileSecurity from '#components/ProfileSecurity'
import ProfileUser from '#components/ProfileUser'

type Context = {
  kiosk: Kiosk,
}

const tp = i18n.prefix('components.Profile')

const Profile = (_: *, ctx: Context) => {
  const content = (
    <React.Fragment>
      <ProfileUser/>
      <ProfileSecurity/>
      <ProfilePreferences/>
    </React.Fragment>
  )

  return ctx.kiosk.isKioskMode === false
    ? (
      <React.Fragment>
        <HeaderTitle>{tp('profile')}</HeaderTitle>
        <DocumentTitle>{tp('profile')} | Vimcar</DocumentTitle>
        <Page>
          {content}
        </Page>
      </React.Fragment>
    )
    : content
}

Profile.contextTypes = {
  kiosk: PT.object,
}

export default Profile
